import { useState, useEffect } from "react";
import "./AdminLogin.css";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

function AdminLogin() {
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (localStorage.getItem("es_token")) {
      window.location.href = "/admin/dashboard";
    }
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    const { email, password } = e.target.elements;
    try {
      const res = await fetch(`${API}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.value, password: password.value }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Invalid credentials");
      localStorage.setItem("es_token", data.token);
      window.location.href = "/admin/dashboard";
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="al-root">
      <div className="al-card">
        <div className="al-brand">
          <span className="al-brand-label">Exyst Space</span>
          <div className="al-brand-title">Admin</div>
          <div className="al-divider" />
        </div>

        <form className="al-form" onSubmit={handleSubmit} autoComplete="off">
          <div className="al-field">
            <label className="al-label" htmlFor="al-email">Email</label>
            <input
              className="al-input"
              id="al-email"
              name="email"
              type="email"
              required
              placeholder="admin@exystspace.com"
              autoComplete="username"
            />
          </div>

          <div className="al-field">
            <label className="al-label" htmlFor="al-password">Password</label>
            <div className="al-input-wrap">
              <input
                className="al-input has-toggle"
                id="al-password"
                name="password"
                type={showPass ? "text" : "password"}
                required
                placeholder="••••••••"
                autoComplete="current-password"
              />
              <button
                type="button"
                className="al-toggle"
                onClick={() => setShowPass((p) => !p)}
              >
                {showPass ? "HIDE" : "SHOW"}
              </button>
            </div>
          </div>

          <div className={`al-error${error ? " visible" : ""}`}>{error}</div>

          <button className="al-btn" type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <div className="al-footer">Exyst Space &mdash; Admin Portal</div>
      </div>
    </div>
  );
}

export default AdminLogin;
